import {Fragment} from 'react';

import {gettext} from 'topmeteo/utils/i18n';
import {MetSelectList} from 'topmeteo/general/components/MetSelectWrapper';

import LocationItem from './LocationItem';
import LocationManager from './LocationManager';

const Style = {
    width: 'auto',
    minWidth: '100%',
};

const LocationManagerLabel = gettext('Configure Locations…');

const Divider = () => <li className="divider" />;

const LocationList = ({selected, locations, isAnonymous, ...props}) => (
    <MetSelectList {...props} style={Style}>
        {locations.map(location => (
            <LocationItem
                {...location}
                key={location.id}
                isAnonymous={isAnonymous}
                isSelected={location.id === selected}
                isUnavailable={location.region === null}
            />
        ))}
        {isAnonymous || (
            <Fragment>
                <Divider />
                <LocationManager>
                    <li className="configure-locations">
                        <span className="change-location">
                            {LocationManagerLabel}
                        </span>
                    </li>
                </LocationManager>
            </Fragment>
        )}
    </MetSelectList>
);

export default LocationList;
